import { render, staticRenderFns } from "./service-importer-page.vue?vue&type=template&id=65880ff1&"
import script from "./service-importer-page.vue?vue&type=script&lang=js&"
export * from "./service-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports